import { createFeatureSelector, createSelector } from '@ngrx/store';

import { RequestStatus } from '../../enums/request-status.enum';
import { PowerPagesState } from './power-pages.reducer';

export const selectPowerPagesState = createFeatureSelector<PowerPagesState>('powerPages');

export const selectPowerPages = createSelector(
  selectPowerPagesState,
  (state) => state.powerPages
);

export const selectPowerPagesMeta = createSelector(
  selectPowerPagesState,
  (state) => state.meta
);

export const selectPowerPagesLoading = createSelector(
  selectPowerPagesState,
  (state) => state.listStatus === RequestStatus.Loading
);

export const selectPowerPageDeleting = createSelector(
  selectPowerPagesState,
  (state) => state.deleteStatus === RequestStatus.Loading
);

export const selectPowerPageDuplicating = createSelector(
  selectPowerPagesState,
  (state) => state.duplicateStatus === RequestStatus.Loading
);

export const selectPowerPagesError = createSelector(
  selectPowerPagesState,
  (state) => state.error
);

export const selectPowerPagesLastQuery = createSelector(
  selectPowerPagesState,
  (state) => state.lastQuery
);

/* -------------------------------------------------------------------------- */
/* Editor selectors                                                            */
/* -------------------------------------------------------------------------- */

export const selectCurrentPowerPage = createSelector(
  selectPowerPagesState,
  (state) => state.currentPowerPage
);

export const selectPowerPageOptions = createSelector(
  selectPowerPagesState,
  (state) => state.options
);

export const selectPowerPageLoading = createSelector(
  selectPowerPagesState,
  (state) => state.detailStatus === RequestStatus.Loading
);

export const selectPowerPageOptionsLoading = createSelector(
  selectPowerPagesState,
  (state) => state.optionsStatus === RequestStatus.Loading
);

export const selectPowerPageSaving = createSelector(
  selectPowerPagesState,
  (state) => state.saveStatus === RequestStatus.Loading
);

export const selectPowerPageSaveError = createSelector(
  selectPowerPagesState,
  (state) => state.saveError
);

/* -------------------------------------------------------------------------- */
/* Content block selectors                                                     */
/* -------------------------------------------------------------------------- */

export const selectPowerPageBlocks = createSelector(
  selectPowerPagesState,
  (state) => state.blocks
);

export const selectPowerPageBlocksLoading = createSelector(
  selectPowerPagesState,
  (state) => state.blocksStatus === RequestStatus.Loading
);

export const selectPowerPageBlockSaving = createSelector(
  selectPowerPagesState,
  (state) => state.blockSaveStatus === RequestStatus.Loading
);

/** Raw block save status, so consumers can distinguish Success from Error. */
export const selectPowerPageBlockSaveStatus = createSelector(
  selectPowerPagesState,
  (state) => state.blockSaveStatus
);

export const selectPowerPageBlockDeleting = createSelector(
  selectPowerPagesState,
  (state) => state.blockDeleteStatus === RequestStatus.Loading
);

export const selectPowerPageBlockError = createSelector(
  selectPowerPagesState,
  (state) => state.blockError
);
